import styled from 'styled-components';
import { Select, FormControl } from '@material-ui/core';

interface IContainer {
  offsetTop: number;
}

export const Container = styled.div<IContainer>`
  --offset-top: ${({ offsetTop }) => offsetTop}px;

  padding: 16px 24px 24px 24px;
  min-height: calc(100vh - var(--offset-top));
  background: #fcfeff;
`;

export const Title = styled.div`
  font-size: 24px;
  color: #1a1b1c;
`;
export const FormContainer = styled.form`
  /* Layout Properties */
  width: 100%;
  height: 320px;
  display: flex;
  flex-direction: column;
  padding-left: 32px;
  padding-right: 32px;
  overflow: auto;
  justify-content: start;
  align-items: start;
`;
export const StyledFormControl = styled(FormControl)`
  margin-top: 20px !important;
  margin-bottom: 10px;
  width: 220px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
`;
export const StyledLabel = styled.label`
  margin-top: 20px;
  width: 100%;
  margin-bottom: 10px;
`;
export const StyledSelect = styled(Select)`
  //margin: 1px,
  //min-width: 120px,
  border: none !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  color: #787878;
  ::placeholder {
    color: #787878;
  }
`;
export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Button = styled.button`
  background: #1371fe;
  margin-top: 16px;
  cursor: pointer;
  color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  border: none;
  padding: 12px 20px 12px 0;
  display: flex;
  align-items: center;

  :disabled {
    background: #f1f1f1;
    cursor: default;
  }
`;

export const Icon = styled.img`
  margin-right: 8px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
`;

export const StyledInput = styled.input`
  border: none;
  width: 220px;
  margin-top: 10px !important;
  height: 40px;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  //display: flex;
  align-items: start;
  padding-left: 10px;
  padding-right: 8px;

  ::placeholder {
    color: #787878;
  }
`;

export const StyledTextArea = styled.textarea`
  border: none;
  width: 300px;
  height: 100px;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  //display: flex;
  align-items: start;
  margin-top: 20px;
  padding-left: 10px;
  padding-right: 8px;

  ::placeholder {
    color: #787878;
  }
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;

export const Filter = styled.div`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  max-width: 449px;
  width: 100%;
`;
